module.exports = __webpack_public_path__ + "static/mobile-element-1-2e32159d985a6a2091288988818f7985.png";